/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Language } from '../models/Language';
import type { LanguagePartial } from '../models/LanguagePartial';
import type { LanguageWithRelations } from '../models/LanguageWithRelations';
import type { loopback_Count } from '../models/loopback_Count';
import type { NewLanguage } from '../models/NewLanguage';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class LanguageControllerService {

    /**
     * @returns loopback_Count Language model count
     * @throws ApiError
     */
    public static languageControllerCount({
        where,
    }: {
        where?: any,
    }): CancelablePromise<loopback_Count> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/languages/count',
            query: {
                'where': where,
            },
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static languageControllerUpdateById({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: LanguagePartial,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/languages/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns LanguageWithRelations Language model instance
     * @throws ApiError
     */
    public static languageControllerFindById({
        id,
        filter,
    }: {
        id: string,
        filter?: any,
    }): CancelablePromise<LanguageWithRelations> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/languages/{id}',
            path: {
                'id': id,
            },
            query: {
                'filter': filter,
            },
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static languageControllerDeleteById({
        id,
    }: {
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/languages/{id}',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns Language Language model instance
     * @throws ApiError
     */
    public static languageControllerCreate({
        requestBody,
    }: {
        requestBody?: NewLanguage,
    }): CancelablePromise<Language> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/languages',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns LanguageWithRelations Array of Language model instances
     * @throws ApiError
     */
    public static languageControllerFind({
        filter,
    }: {
        filter?: any,
    }): CancelablePromise<Array<LanguageWithRelations>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/languages',
            query: {
                'filter': filter,
            },
        });
    }

}
